export const SELECTED_PRODUCT_LS_KEY = 'selected-product';
export const NOTIFY_CREATOR_TIMESTAMPS_LS_KEY = 'notify-creator-timestamps';
export const OVERVIEW_RECENT_SEARCHES_LS_KEY = 'overview-recent-searches';
export const CLIENT_RECENT_SEARCHES_LS_KEY = 'client-recent-searches';
export const UNIT_RECENT_SEARCHES_LS_KEY = 'unit-recent-searches';
export const SERVICE_RECENT_SEARCHES_LS_KEY = 'service-recent-searches';
export const CUSTOM_TAGS_RECENT_SEARCHES_LS_KEY = 'custom-tags-recent-searches';
export const GLOBAL_RECENT_SEARCHES_LS_KEY = 'global-recent-searches';
